<template>
    <div class="filePreview">
    	<div class="previewPrint">
            <p><strong>The file previews displayed to the left are how your files will be sent to print.</strong></p>
            <p class="m-b-20">Please double check all text and spelling for possible errors. If anything looks incorrect, click on "Back To Designer" to go back and correct before proceeding. Otherwise, please check and approve each file below:</p>
            <table class="table m-0">
                <tbody>
                    <tr v-for="file in fileList" v-if="hasFile(file)" @mouseover="setPreview(file)">
                        <td>
                            <h5 class="m-b-5">{{ file.replace(/_/g,' ').replace(/v/g,'V').replace(/\b\w/g, l => l.toUpperCase()) }}</h5>
                            <p>{{ description[file] }}</p>
                        </td>
                        <td style="text-align: right;">
                            <transition-group enter-active-class="animated fadeInRight" leave-active-class="animated fadeOut">
                                <i key="1" class="icon-checkmark-circle pull-right m-t-10" v-if="approved.includes(file)"></i>
                                <button key="2" v-if="pending.includes(file)" @click.stop="approve(file)" class="btn btn-warning pull-right m-t-10">
                                    {{ (pending.includes(file)) ? 'Approve' : 'Approved' }}
                                </button>
                            </transition-group>
                        </td>
                    </tr>
                </tbody>
            </table>

            <transition-group enter-active-class="animated fadeInDown">
                <hr key="1" v-if="pending.length === 0 && approved.length > 0" class="m-t-0" />
                <button key="2" v-if="pending.length === 0 && approved.length > 0" class="btn btn-success pull-right" @mouseover="setPreview('front')" @click="checkProceed()">Continue to Product Selection</button>
            </transition-group>
    	</div>
    </div>
</template>

<script>
export default {
    name: 'FileApproval',
    data () {
        return {
            files: {
                default: null
            },
            fileList: ['front', 'back', 'foil_front', 'foil_back', 'spot_uv_front', 'spot_uv_back'],
            approved: [],
            pending: [],
            description: {
                front: 'The front design file.',
                back: 'The back design file.',
                foil_front: 'The front foil mask. Dark parts of preview will have foil over top of them.',
                foil_back: 'The back foil mask. Dark parts of preview will have foil over top of them.',
                spot_uv_front: 'The front spot uv mask. Dark parts of preview will have spot uv (gloss) printed over top of them.',
                spot_uv_back: 'The back spot uv mask. Dark parts of preview will have spot uv (gloss) printed over top of them.'
            }
        }
    },
    beforeMount () {
        this.files = this.$store.state.template.files
    },
    mounted () {
        let time = 250
        for (let file in this.fileList) {
            setTimeout(() => {
                this.pending.push(this.fileList[file])
            }, time)
            time += 250
        }
    },
    methods: {
        toggle: function (target) {
            $(target).toggleClass('hide')
        },

        setPreview (file) {
            this.$emit('preview', file)
        },

        hasFile: function (file) {
            if (file !== undefined) {
                if (this.files[file] === undefined) {
                    let index = this.pending.indexOf(file)

                    if (index > -1) {
                        this.pending.splice(index, 1)
                    }
                    return false
                }
                return true
            }
            return false
        },

        approve: function (file) {
            if (this.pending.includes(file)) {
                let index = this.pending.indexOf(file)

                if (index > -1) {
                    this.pending.splice(index, 1)
                }
            }

            if (!this.approved.includes(file)) {
                this.approved.push(file)
            }
        },

        checkProceed () {
            if (this.pending.length < 1) {
                this.$emit('next')
            }
            return false
        }
    }
}
</script>

<style lang="scss" scoped>
    .btn-warning {
        background-color: #FF9D00;
    }
    .icon-checkmark-circle {
        font-size: 1.6em;
        position: relative;
        top: 7px;
        color: #5DB75C;
    }
    h5{
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// FileApproval.vue?15334a55